import ConfigurationReference from '../../constants/configurationReference';
import Request from './request';

export default class ConfigurationHttpService {
    private static uri = 'configurations';

    public static readOne(reference: ConfigurationReference) {
        return Request.get(`${this.uri}/${reference}`);
    }

    public static update(
        reference: ConfigurationReference,
        configuration: { value: string | null },
    ) {
        return Request.patch(`${this.uri}/${reference}`, configuration);
    }
}
